import { useState, useEffect } from "react";

const EMPTY = { name: "", customName: "", level: "", description: "" };
const NO_ERRORS = { name: "", customName: "", level: "" };

export const useCompetencyForm = (t, initialCompetencies = []) => {
  const [competency, setCompetency] = useState(EMPTY);
  const [errors, setErrors] = useState(NO_ERRORS);
  const [competencies, setCompetencies] = useState([]);

  useEffect(() => {
    if (initialCompetencies && initialCompetencies.length > 0) {
      setCompetencies(initialCompetencies.map((comp) => ({
        ...comp,
        id: comp.id || Date.now() + Math.random(),
      })));
    }
  }, [initialCompetencies]);

  const handleCompetencyChange = (e) => {
    const { name, value } = e.target;
    setCompetency((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => (prev[name] ? { ...prev, [name]: "" } : prev));
  };

  /** True when the user typed anything in the sub-form but did not add it. */
  const hasPendingInput = () =>
    Boolean(competency.name || competency.customName.trim() || competency.level || competency.description.trim());

  const validateCompetency = () => {
    const next = { ...NO_ERRORS };
    if (!competency.name) next.name = t("Competency name is required");
    if (competency.name === "others" && !competency.customName.trim()) next.customName = t("Custom competency name is required");
    if (!competency.level) next.level = t("Proficiency level is required");
    return next;
  };

  /** Validates and adds; returns { ok, competencies } synchronously. */
  const addCompetency = () => {
    const next = validateCompetency();
    setErrors(next);
    if (Object.values(next).some(Boolean)) return { ok: false, competencies };

    const updated = [...competencies, { ...competency, id: Date.now() }];
    setCompetencies(updated);
    setCompetency(EMPTY);
    setErrors(NO_ERRORS);
    return { ok: true, competencies: updated };
  };

  const clearPending = () => {
    setCompetency(EMPTY);
    setErrors(NO_ERRORS);
  };

  const removeCompetency = (id) => {
    setCompetencies((prev) => prev.filter((comp) => comp.id !== id));
  };

  return {
    competency,
    competencies,
    errors,
    handleCompetencyChange,
    addCompetency,
    removeCompetency,
    hasPendingInput,
    clearPending,
  };
};
